import { defineComponent as O, useSlots as V, useTemplateRef as E, inject as v, ref as U, computed as C, watchEffect as j, onMounted as z, onBeforeUnmount as F, createBlock as L, openBlock as m, resolveDynamicComponent as $, mergeProps as w, unref as t, withCtx as y, createVNode as T, createElementBlock as b, createCommentVNode as A, createElementVNode as g, normalizeClass as c, renderSlot as k } from "vue";
import { useElementHover as q, isDefined as G } from "@vueuse/core";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Nav/nav.js";
import J from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Divider/divider.js";
import { AngleRightIcon as Q } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { NavOnSelectKey as W, NavFlyoutRefKey as X } from "./Nav.vue2.js";
import { SidebarOpenKey as Y } from "../Page/PageSidebar.vue2.js";
import Z from "../../helpers/FloatingUi.vue2.js";
import { useOUIAProps as _ } from "../../helpers/ouia.js";
const x = { ref: "floatingRef" }, fe = /* @__PURE__ */ O({
  name: "PfNavItem",
  inheritAttrs: !1,
  __name: "NavItem",
  props: {
    component: { default: "li" },
    linkComponent: {},
    groupId: {},
    itemId: {},
    active: { type: Boolean },
    preventDefault: { type: Boolean },
    itemClass: {},
    itemAttrs: {},
    to: {},
    tabindex: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["showflyout", "select"],
  setup(B, { emit: N }) {
    const n = B, D = _({ id: n.ouiaId, safe: n.ouiaSafe }), I = N, d = V(), f = E("elRef"), M = E("floatingRef"), p = v(W, void 0), i = v(X, null), R = v(Y, !1), u = U(null), S = q(M), H = C(() => n.linkComponent ? n.linkComponent : n.linkComponent ?? (d.flyout ? "button" : n.to === void 0 ? "a" : "router-link")), a = C({
      get() {
        return G(f.value) && f.value === (i == null ? void 0 : i.value);
      },
      set(e) {
        i && (i.value = e ? f.value : null), e && I("showflyout");
      }
    });
    j(() => {
      if (u.value)
        if (a.value) {
          const e = u.value.nextElementSibling, s = e ? Array.from(e.getElementsByTagName("UL")[0].children).filter(
            (r) => !(r.classList.contains("pf-m-disabled") || r.classList.contains(J.divider))
          ) : [], l = s.length ? s[0].firstElementChild : null;
          l instanceof HTMLElement && l.focus();
        } else
          u.value.focus();
    }), z(() => {
      window.addEventListener("click", h);
    }), F(() => {
      window.removeEventListener("click", h);
    });
    function P(e) {
      e && n.preventDefault && e.preventDefault(), I("select", e, n.groupId, n.itemId), p == null || p(e, n.groupId, n.itemId);
    }
    function K(e) {
      var s;
      if (!(!d.flyout || !(e.target instanceof HTMLElement)) && ((e.key === " " || e.key === "ArrowRight") && (e.stopPropagation(), e.preventDefault(), a.value || (a.value = !0, u.value = e.target)), (e.key === "Escape" || e.key === "ArrowLeft") && a.value)) {
        e.stopPropagation(), e.preventDefault();
        let l = e.target.closest(`.${o.navItem}.pf-m-flyout`);
        if (e.target.parentElement === l && (l = ((s = l == null ? void 0 : l.parentElement) == null ? void 0 : s.closest(`.${o.navItem}.pf-m-flyout`)) ?? null), l) {
          const r = l.firstElementChild;
          r instanceof HTMLElement && r.focus();
        }
        a.value = !1;
      }
    }
    function h(e) {
      if (!(e.target instanceof HTMLElement))
        return;
      e.target.closest(".pf-m-flyout") || (a.value = !!d.flyout);
    }
    return (e, s) => (m(), L($(e.component), w({
      ref: "elRef",
      class: [t(o).navItem, e.itemClass, {
        [t(o).modifiers.flyout || "pf-m-flyout"]: e.$slots.flyout
      }]
    }, { ...t(D), ...e.itemAttrs }, {
      onKeydown: K,
      onMouseover: s[0] || (s[0] = (l) => a.value = !!e.$slots.flyout)
    }), {
      default: y(() => [
        (m(), L($(H.value), w({
          class: [t(o).navLink, {
            [t(o).modifiers.current]: e.active,
            [t(o).modifiers.hover]: t(S)
          }],
          "aria-current": e.active ? "page" : null,
          to: e.to,
          "active-class": e.to ? t(o).modifiers.current : null,
          tabindex: e.tabindex || t(R) ? null : "-1"
        }, e.$attrs, { onClick: P }), {
          default: y(() => [
            e.$slots.icon ? (m(), b("span", {
              key: 0,
              class: c(t(o).navLinkIcon)
            }, [
              k(e.$slots, "icon")
            ], 2)) : A("", !0),
            g("span", {
              class: c(`${t(o).navLink}-text`)
            }, [
              k(e.$slots, "default")
            ], 2),
            e.$slots.flyout ? (m(), b("span", {
              key: 1,
              class: c(t(o).navToggle)
            }, [
              g("span", {
                class: c(t(o).navToggleIcon)
              }, [
                T(t(Q), { "aria-hidden": "" })
              ], 2)
            ], 2)) : A("", !0)
          ]),
          _: 3
        }, 16, ["class", "aria-current", "to", "active-class", "tabindex"])),
        T(Z, {
          hidden: !a.value,
          reference: t(f),
          placement: "right-start"
        }, {
          default: y(() => [
            g("div", x, [
              k(e.$slots, "flyout")
            ], 512)
          ]),
          _: 3
        }, 8, ["hidden", "reference"])
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  fe as default
};
